const utils = require('../../utils')
import dayjs from 'dayjs'
import html2Canvas from 'html2canvas'
import $ from "jquery"
global.jQuery = $;
window.jQuery = $;

export default {
  name: 'es-mycard-detail',
  filters: {
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    }
  },
  data: () => ({
    card: {},
    isFavorited: false,
    isHamburgerListShow: false,
    isDeleteConfirmModal: false,
    isDeleteCardCompleteModal: false,
    isLiked: false,
    isReportProblemModal: false,
    isProblemReported: false,
    isGetEsMycard: false,
    isLikePushing: false
  }),
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    getFavoriteImageByState () {
      return state => {
        if (state) {
          return require('../images/icon_star_yellow.png')
        }
        return require('../images/icon_star_blank.png')
      }
    },
    getLikeImageByState () {
      return state => {
        if (state) {
          return require('../images/icon_heart_pink.png')
        }
        return require('../images/icon_heart_blank.png')
      }
    },
    // 背景画像パス生成
    getBackgroundImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/background/${imageName}.png`)
      }
    },
    // 対面授受画像パス生成
    getFacingtypeImageByImage () {
      return imagePath => {
        return `${imagePath}`
      }
    },
    // プロフィール画像パス生成
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}?token=${this.authToken}&timestamp=${this.timeStamp}`
        }
        return require('../images/img_profile.png')
      }
    },
    // キャラクター画像パス生成
    getCharacter1ImageByImageName () {
      return (pathName, imageName) => {
        return require(`../../../static/mycard/character1/${pathName}/${imageName}.png`)
      }
    },
    // キャラクター画像パス生成
    getCharacter2ImageByImageName () {
      return (imageName) => {
        return require(`../../../static/mycard/character2/${imageName}.png`)
      }
    },
    setClassCommentFontSize () {
      const count = this.card.comments.length
      if (count <= 50) return "big"
      if (count <= 80) return "middle"
      return "small"
    }
  },
  created: async function () {
    // ESmyカード情報取得
    await this.getEsMycard()
    // 既読設定
    await this.updEsMycardRead()
  },
  methods: {
    authorityCheck: function () {
      if (localStorage.user_authority == 1) {
        return true
      }
      if (localStorage.user_authority <= 2 && this.card.give_user_shop_id == localStorage.shop_id) {
        return true
      }
      return false
    },
    goBack: function () {
      if (window.sessionStorage.getItem('es_mycard_detail_referrer')) {
        const referrer = window.sessionStorage.getItem('es_mycard_detail_referrer')
        window.sessionStorage.removeItem('es_mycard_detail_referrer')
        this.$router.push({ path: referrer})
      } else {
        // 特に戻り先の指定がない場合は、ESmyカード一覧へ戻る
        this.$router.push({ path: '/es_mycard_list' })
      }
    },
    goProfile: function (id) {
      window.sessionStorage.setItem('profile_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/profile/' + id })
    },
    goEsMycardList: function () {
      this.isDeleteCardCompleteModal = false
      this.$router.push({ path: '/es_mycard_list'})
    },
    goEsMycardLikeList: function () {
      window.sessionStorage.setItem('es_mycard_like_list_referrer', this.$router.history.current.path)
      this.$router.push({ path: `/like_list/${this.$route.params.es_mycard_id}` })
    },
    async downloadCardById () {
      $('.get_user_box').addClass('print_margin_get')
      // 画像ダウンロード処理
      const canvas = await html2Canvas(this.$refs.es_mycard_download)
      const dummyLink = document.createElement('a')
      dummyLink.href = canvas.toDataURL("image/jpeg")
      dummyLink.download = `esmycard_${dayjs().format('YYYYMMDD')}.jpeg`
      dummyLink.click()
      this.toggleHamburger()
      $('.get_user_box').removeClass('print_margin_get')
    },
    showDeleteCardModal () {
      this.isDeleteConfirmModal = true
      this.toggleHamburger()
    },
    async sendFavorite () {
      // お気に入りボタンを押した時の処理
      this.isFavorited = !this.isFavorited
      const data = {
        card_id: this.$route.params.es_mycard_id
      }
      await this.$store.dispatch('CARD_FAVORITE_UPDATE', { data: data })
      .catch(err => {
        console.error(err)
        return
      })
    },
    toggleHamburger () {
      // メニューリスト
      this.isHamburgerListShow = !this.isHamburgerListShow
    },
    async deleteCardByTargetId () {
      // カードを削除する
      const data = {
        card_id: this.$route.params.es_mycard_id
      }
      await this.$store.dispatch('CARD_DELETE', { data: data })
      .catch(err => {
        console.error(err)
        return
      })
      this.isDeleteConfirmModal = false
      this.isDeleteCardCompleteModal = true
    },
    async sendLike () {
      // いいねボタンを押したときの処理
      if (!this.isLikePushing) {
        this.isLikePushing = true
        this.isLiked = !this.isLiked
        const data = {
          card_id: this.$route.params.es_mycard_id
        }
        const res = await this.$store.dispatch('CARD_LIKE_UPDATE', { data: data })
        .catch(err => {
          console.error(err)
          return
        })
        if (res.success === 'delete') {
          this.card.like -= 1
        } else {
          this.card.like += 1
        }
        this.isLikePushing = false
      }
    },
    currentUserId () {
      return Number(window.localStorage.getItem('user_id'))
    },
    getEsMycard: async function () {
      const res = await this.$store.dispatch('GET_MYCARD_DETAIL', {id: this.$route.params.es_mycard_id})
      .catch(err => {
        console.error(err)
        return
      })
      if (res.card_detail.is_already_read == 0) {
        this.updEsMycardRead()
      }
      this.card = res.card_detail
      this.isFavorited = this.card.you_favorited
      this.isLiked = this.card.you_liked
      this.isGetEsMycard = true
    },
    updEsMycardRead: async function () {
      // 自分宛未読カードを開いた場合
      if (this.currentUserId() === this.card.get_user_id && !this.card.is_already_read) {
        await this.$store.dispatch('CARD_UPDATE', {id: this.$route.params.es_mycard_id})
        .catch(err => {
          console.error(err)
          return
        })
      }
    },
    rmEmoji: function(text) {
      this.card.problem_report_reason = utils.removeEmoji(text)
    },
    cancelReportProblem: function() {
      // 問題報告キャンセル処理
      this.isReportProblemModal = false
      this.card.problem_report_reason = ''
    },
    showReportProblem: function () {
      // 問題報告モーダル表示
      this.isReportProblemModal = true
      this.isHamburgerListShow = false
    },
    reportProblem: async function () {
      // ボタン連打時に複数報告されないように制御
      if (this.isProblemReported) return
      this.isProblemReported = true
      // 問題報告処理
      const data = {
        id: this.$route.params.es_mycard_id,
        problem_report_user_id: localStorage.user_id,
        problem_report_reason: this.card.problem_report_reason,
        url: process.env.ASOVI_URL + `/#/es_mycard/${this.$route.params.es_mycard_id}/detail`
      }
      await this.$store.dispatch('PROBLEM_REPORT_UPDATE', data)
      .catch(err => {
        console.error(err)
        return
      })
      this.isReportProblemModal = false
      this.card.is_problem_reported = 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-detail.js